module.exports = __webpack_public_path__ + "img/Karolina.1ec28c21.jpg";